<div id="page-assertion" class="public-portal-right-col">
    <h1 id="section-title" class="wt-access">Confirm</h1>
    
    <div style="padding-bottom: 0;">
        <img alt="Welltrack secondary logo" id="text-logo" src="./assets/img/welltrack-logos/welltrack-boost-logo.png">
    </div>

    <div class="center padding" style="margin-top: 100px;">
        <code>{{decodedText}}</code>
    </div>
</div>